"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCreditNoteRequest = exports.transformCreditNoteListResponse = exports.transformCreditNoteResponse = void 0;
const Error_1 = require("./Error");
const Money_1 = require("./Money");
const Line_1 = require("./Line");
const Date_1 = require("./Date");
var CreditType;
(function (CreditType) {
    CreditType["goodwill"] = "goodwill";
    CreditType["overpayment"] = "overpayment";
    CreditType["prepayment"] = "prepayment";
})(CreditType || (CreditType = {}));
var DisplayStatus;
(function (DisplayStatus) {
    DisplayStatus["draft"] = "draft";
    DisplayStatus["created"] = "created";
    DisplayStatus["sent"] = "sent";
    DisplayStatus["viewed"] = "viewed";
})(DisplayStatus || (DisplayStatus = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["unpaid"] = "unpaid";
    PaymentStatus["partial"] = "partial";
    PaymentStatus["paid"] = "paid";
})(PaymentStatus || (PaymentStatus = {}));
var LastOrderStatus;
(function (LastOrderStatus) {
    LastOrderStatus["pending"] = "pending";
    LastOrderStatus["declined"] = "declined";
    LastOrderStatus["success"] = "success";
})(LastOrderStatus || (LastOrderStatus = {}));
var DisputeStatus;
(function (DisputeStatus) {
    DisputeStatus["disputed"] = "disputed";
    DisputeStatus["resolved"] = "resolved";
})(DisputeStatus || (DisputeStatus = {}));
function transformCreditNoteResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { credit_notes } = response.response.result;
    return transformCreditNoteParsedResponse(credit_notes);
}
exports.transformCreditNoteResponse = transformCreditNoteResponse;
function transformCreditNoteListResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { credit_notes, per_page, total, page, pages } = response.response.result;
    return {
        creditNotes: credit_notes.map((creditNote) => transformCreditNoteParsedResponse(creditNote)),
        pages: {
            total,
            size: per_page,
            pages,
            page,
        },
    };
}
exports.transformCreditNoteListResponse = transformCreditNoteListResponse;
function transformCreditNoteParsedResponse(creditNote) {
    return {
        id: creditNote.id,
        creditId: creditNote.creditid,
        accountingSystemId: creditNote.accounting_systemid,
        clientId: creditNote.clientid,
        code: creditNote.code,
        sentId: creditNote.sentid,
        amount: creditNote.amount && (0, Money_1.transformMoneyParsedResponse)(creditNote.amount),
        city: creditNote.city,
        country: creditNote.country,
        createDate: creditNote.create_date && (0, Date_1.transformDateResponse)(creditNote.create_date, Date_1.DateFormat['YYYY-MM-DD']),
        creditNumber: creditNote.credit_number,
        creditType: creditNote.credit_type,
        currencyCode: creditNote.currency_code,
        currentOrganization: creditNote.current_organization,
        description: creditNote.description,
        displayStatus: creditNote.display_status,
        disputeStatus: creditNote.dispute_status,
        extArchive: creditNote.ext_archive,
        fName: creditNote.fname,
        language: creditNote.language,
        lastOrderStatus: creditNote.last_order_status,
        lines: creditNote.lines && creditNote.lines.map((line) => (0, Line_1.transformLineParsedResponse)(line)),
        lName: creditNote.lname,
        notes: creditNote.notes,
        organization: creditNote.organization,
        paid: creditNote.paid && (0, Money_1.transformMoneyParsedResponse)(creditNote.paid),
        paymentStatus: creditNote.payment_status,
        paymentType: creditNote.payment_type,
        province: creditNote.province,
        status: creditNote.status,
        street: creditNote.street,
        street2: creditNote.street2,
        template: creditNote.template,
        terms: creditNote.terms,
        vatName: creditNote.vat_name,
        vatNumber: creditNote.vat_number,
        visState: creditNote.vis_state,
    };
}
function transformCreditNoteRequest(creditNote) {
    return JSON.stringify({
        credit_notes: {
            accounting_systemid: creditNote.accountingSystemId,
            amount: creditNote.amount && (0, Money_1.transformMoneyParsedRequest)(creditNote.amount),
            city: creditNote.city,
            clientid: creditNote.clientId,
            country: creditNote.country,
            code: creditNote.code,
            create_date: creditNote.createDate && (0, Date_1.transformDateRequest)(creditNote.createDate),
            credit_number: creditNote.creditNumber,
            credit_type: creditNote.creditType,
            creditid: creditNote.creditId,
            current_organization: creditNote.currentOrganization,
            currency_code: creditNote.currencyCode,
            description: creditNote.description,
            display_status: creditNote.displayStatus,
            dispute_status: creditNote.disputeStatus,
            ext_archive: creditNote.extArchive,
            fname: creditNote.fName,
            id: creditNote.id,
            language: creditNote.language,
            last_order_status: creditNote.lastOrderStatus,
            lname: creditNote.lName,
            lines: creditNote.lines && creditNote.lines.map((line) => (0, Line_1.transformLineParsedRequest)(line)),
            notes: creditNote.notes,
            organization: creditNote.organization,
            paid: creditNote.paid && (0, Money_1.transformMoneyParsedRequest)(creditNote.paid),
            payment_status: creditNote.paymentStatus,
            payment_type: creditNote.paymentType,
            province: creditNote.province,
            sentid: creditNote.sentId,
            status: creditNote.status,
            street: creditNote.street,
            street2: creditNote.street2,
            template: creditNote.template,
            terms: creditNote.terms,
            vat_name: creditNote.vatName,
            vat_number: creditNote.vatNumber,
            vis_state: creditNote.visState,
        },
    });
}
exports.transformCreditNoteRequest = transformCreditNoteRequest;
//# sourceMappingURL=CreditNote.js.map